export default __webpack_public_path__ + "static/media/24.1bd19d5a.png";